<template>
    <v-tab-item :value="NEWS.value">
        <about-list/>
    </v-tab-item>
</template>

<script>
import { ABOUT_US_TABS } from "@/assets/variables";
import AboutList from "@/components/client/ko/board/about/list.vue"
const { NEWS } = ABOUT_US_TABS;
export default {
    data() {
        return {
            NEWS,
        };
    },
    components: {
        AboutList
    },
};
</script>

<style scoped>

@media (min-width:576px){
}
@media (min-width:768px){
}
@media (min-width:1024px){
}
@media (min-width:1200px){
}

</style>
